import { gql } from '@apollo/client';

export const getCheckoutHealthOffers = gql`query checkoutHealthOffers($soId: String!){
    health {
        checkoutHealthOffers( soId: $soId ) {
            _id
            publicSoId
            publicOfferId
            brandId
            status
            paidAt
            isPublished
            annotations
            termsAcceptedAt
            iddTermsAcceptedAt
            allianzGDPRAcceptedAt
            acceptedEmailDocumentationDeliveryAt
            supplementary {
                label
                code
                brandName
                brandCode
                logoUrl
                numberOfInstallments
                baseProductPrice
                actionLabel
                includedInPrice {
                    label
                    description
                  }
                additionalCoverages {
                    label
                    description
                }
            }
            additional {
                label
                code
                brandName
                brandCode
                logoUrl
                numberOfInstallments
                baseProductPrice
            }
            total {
                generalTransfer
                generalTransferWithInstallments
                creditCard
                creditCardWithInstallments
            }
        }
    }
}
`;